














































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue } from 'vue-property-decorator';
import CBudgetSumCalcFilter from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-filter.vue';
import CBudgetSumCalcCostTab from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-cost-table.vue';
import CBudgetSumCalcIncomeTab from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-income-table.vue';
import CBudgetSumCalcGkkpExpensTab from '@/modules/budget-request/components/budget-sum-calc/budget-sum-calc-gkkp-expens-table.vue';
import Multiselect from 'vue-multiselect';
import { Ax } from '@/utils';
import CBudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import store from '@/services/store';
import { vue } from '@/services/i18n';
import BpI18nHandlerMixin from './mixins/bp-i18n-handler-mixin';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import { makeToast } from '@/modules/budget-request/components/js/some-functions';

@Component({
    components: {
        'c-budg-filter': CBudgetSumCalcFilter,
        'multiselect': Multiselect,
        'c-bud-sum-calc-cost-tab': CBudgetSumCalcCostTab,
        'c-bud-sum-calc-income-tab': CBudgetSumCalcIncomeTab,
        'c-bud-sum-calc-gkkp-expens-tab': CBudgetSumCalcGkkpExpensTab,
        'c-budg-form-lst': CBudgetFormsList
    }
})

export default class CBudgetSumCalc extends Vue {
    private tabIndx = 0;
    private tabIndxSelected = 0;
    private curFormSelect = '/budget-sum-calc';
    private headerData: any | null = null;
    private header: any | null = null;
    private showAdd = false;
    private error: any;
    private dataTypeFilter: any = null;

    private changedDataFl = false; // статус, изменены ли данные в дочерних вкладках

    private reportCodes: any = [
        { code: 'Form_GU', val: 57 },
        { code: 'Form_GU_svod', val: 58 },
        { code: 'Svod_BP', val: 59 },
        { code: 'Svod_BP_BPR', val: 60 },
        { code: 'Svod_BPP', val: null }, // 61
        { code: 'Form_GU_93', val: null },
        { code: 'Form_GU_94', val: null }
    ];

    private curVariant: any | null = null;

    private isAbpLevelUser = false;

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    private enableTab = false;
    private enableIncomeTab = false;
    private enableGkkpExpensTab = false;
    private editableCostAccess = false;
    private editableIncomeAccess = false;
    private editableGkkpExpensAccess = false;
    private adminAccess = false;

    private filter: any = null;

    private get editableIncomeTab() {
        if (!this.editableIncomeAccess) { return false; }
        let fl = false;
        if (this.curVariant && this.curVariant.attribute && !this.curVariant.is_deleted) { fl = true; }
        return fl;
    }

    private get editableCostTab() {
        if (!this.editableCostAccess) { return false; }
        let fl = false;
        if (this.curVariant && this.curVariant.attribute && !this.curVariant.is_deleted) { fl = true; }
        return fl;
    }

    private get editableGkkpExpensTab() {
        if (!this.editableGkkpExpensAccess) { return false; }
        let fl = false;
        if (this.curVariant && this.curVariant.attribute && !this.curVariant.is_deleted) { fl = true; }
        return fl;
    }

    private save() {
        if (this.tabIndxSelected == 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcTab.save();
        } else if (this.tabIndxSelected == 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcIncomeTab.save();
        } else if (this.tabIndxSelected == 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcGkkpExpensTab.save();
        }
    }

    private getFormText(field: string, id: any = -1): any {
        const link = 'modules.budget_request.form_gu.' + field
        if (id >= 0) return this.$tc(link, id);
        return this.$t(link);
    }

    private infoCostForm(info_id: any) {
        const that = this;
        Ax<Blob>(
            {
                url: '/api-py/get-info/' + info_id, //  Тело файла
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                let file = '';
                if (info_id == 10) {
                    file = 'РП_Бюджетные_заявки_сводные_расчеты';
                }
                if (info_id == 49) {
                    file = 'Форма_ГУ_Расходы_ГККП';
                }
                if (info_id == 50) {
                    file = 'ММ_нысаны_МКҚК_шығыстары';
                }
                link.setAttribute('download', file + '.pdf');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                that.error = error;
            }
        );
    }

    private chgData(data: any) {
        this.filter = data;
        if (this.tabIndxSelected === 0) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcTab.chgFilter(this.filter);
        } else if (this.tabIndxSelected === 1) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcIncomeTab.chgFilter(this.filter);
        } else if (this.tabIndxSelected === 2) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.budSumCalcGkkpExpensTab.chgFilter(this.filter);
        }

        this.curVariant = data.curVariant;
        const curHeader = data;
        const budgetVers = curHeader.curVariant ? curHeader.curVariant.variant_uuid : null;
        if (curHeader !== null) {
            this.header = {
                year: curHeader.curYear,
                // eslint-disable-next-line @typescript-eslint/camelcase
                data_type: curHeader.dataType ? curHeader.dataType.code: null,
                gu: curHeader.gu ? curHeader.gu.code: null,
                bin: curHeader.gkkp ? curHeader.gkkp.bin : null,
                budgetVersion: budgetVers,
                budgetVersionName: curHeader.curVariant ? curHeader.curVariant.name : null,
                // eslint-disable-next-line @typescript-eslint/camelcase
                id_region: curHeader.region.code,
                regionName: curHeader.region ? curHeader.region.name: null,
                abp: curHeader.abp.abp,
                prg: curHeader.prg ? curHeader.prg.prg: null,
                ppr: (curHeader.ppr === null ? null : curHeader.ppr.ppr),
                locale: this.$i18n.locale,
                gr: curHeader.gr,
                uid: this.usrId,
                // eslint-disable-next-line @typescript-eslint/camelcase
                date_b: curHeader.curVariant ? curHeader.curVariant.date_start : null,
                // eslint-disable-next-line @typescript-eslint/camelcase
                date_e: curHeader.variantEndDate ? curHeader.variantEndDate : null,
                isFormGuScreen: true
            };
            this.dataTypeFilter = curHeader.dataType.name;
        }
        this.loadAllReportsNumber();
        this.checkAbpLevelUser();
    }

    // проверка принадлежности пользователя к уровню АБП (для доступа к прил. 75-77 и пакетной выгрузке)
    private async checkAbpLevelUser() {
        this.isAbpLevelUser = false;
        if (!this.header || !this.header.uid || !this.header.abp || !this.header.id_region) { return; }
        try {
            const response: any = await fetch(`/api-py/is-form-gu-abp-level-user/${encodeURIComponent(JSON.stringify(this.header))}`, { method: 'POST' });
            if (response.status === 200) {
                this.isAbpLevelUser = await response.json();
            }
        } catch (error) {
            this.isAbpLevelUser = false;
        }
    }

    // получение всех кодов для списка отчетов
    private async loadAllReportsNumber() {
        const result = await Promise.all(this.reportCodes.map((p: any) => this.getNumberReport(p.code)));
        this.reportCodes.forEach((p: any, indx: number) => { p.val = result[indx]; });
    }

    // получение кода(num_pril) отчёта по коду
    private async getNumberReport(formCode: string) {
        let result = '';
        try {
            const response: any = await fetch(`/api-py/get-number-report/${formCode}/${this.header.year}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', `Ошибка /api-py/get-number-report/${formCode}`, (error as Error).toString());
            return null;
        }
        return result;
    }

    private openFilterByRef(refName: string) {
        const foo: any = this.$refs.budgetHeader;
        foo.openFilterByRef(refName);
    }

    private async downloadRep() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            // Первый запрос - получаем prilNum
            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Form_GU' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            // Формируем имя файла после получения prilNum
            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + ' ' + this.getFormText('app_57.dwnld_title_app') + this.getFormText('app_57.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_57.dwnld_title_app') + prilNum + this.getFormText('app_57.dwnld_title_app2')}.xls`;
            }

            // Второй запрос - скачивание файла
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc57/57/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep:', error);
            this.error = error;
        }
    }
    private async downloadRep93() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Form_GU_93' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + this.getFormText('app_57.dwnld_title_app') + this.getFormText('app_57.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_57.dwnld_title_app') + prilNum + this.getFormText('app_57.dwnld_title_app2')}.xls`;
            }

            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc93/93/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep93:', error);
            this.error = error;
        }
    }
    private async downloadRep94() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Form_GU_94' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            const repName = `${that.getBudgetText('sum_calc_edit.reports[6][0]') + prilNum + that.getBudgetText('sum_calc_edit.reports[6][1]')}.xls`;

            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc94/94/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep94:', error);
            this.error = error;
        }
    }
    private async downloadRepSV() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            // Первый запрос - получаем prilNum
            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Form_GU_svod' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            // Формируем имя файла после получения prilNum
            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + ' ' + this.getFormText('app_58.dwnld_title_app') + this.getFormText('app_58.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_58.dwnld_title_app') + prilNum + this.getFormText('app_58.dwnld_title_app2')}.xls`;
            }

            // Второй запрос - скачивание файла
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc57/58/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep:', error);
            this.error = error;
        }
    }
    private async downloadRepBP() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            // Первый запрос - получаем prilNum
            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Svod_BP' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            // Формируем имя файла после получения prilNum
            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + ' ' + this.getFormText('app_59.dwnld_title_app') + this.getFormText('app_59.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_59.dwnld_title_app') + prilNum + this.getFormText('app_59.dwnld_title_app2')}.xls`;
            }

            // Второй запрос - скачивание файла
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc59/59/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep:', error);
            this.error = error;
        }
    }
    private async downloadRepTBP() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            // Первый запрос - получаем prilNum
            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Svod_BP_BPR' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            // Формируем имя файла после получения prilNum
            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + ' ' + this.getFormText('app_60.dwnld_title_app') + this.getFormText('app_60.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_60.dwnld_title_app') + prilNum + this.getFormText('app_60.dwnld_title_app2')}.xls`;
            }

            // Второй запрос - скачивание файла
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc60/60/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep:', error);
            this.error = error;
        }
    }
    private async downloadRepBPR() {
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;

            // Первый запрос - получаем prilNum
            const prilNum = await new Promise<string>((resolve, reject) => {
                Ax(
                    {
                        url: '/api-py/get-number-report/' + 'Svod_BPP' + '/' + that.header.year,
                        method: 'GET'
                    },
                    (data) => {
                        const num = JSON.parse(JSON.stringify(data)) ?? '';
                        resolve(num);
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });

            // Формируем имя файла после получения prilNum
            let repName = '';
            if (this.$i18n.locale === 'kk') {
                repName = `${prilNum + ' ' + this.getFormText('app_61.dwnld_title_app') + this.getFormText('app_61.dwnld_title_app2')}.xls`;
            } else {
                repName = `${this.getFormText('app_61.dwnld_title_app') + prilNum + this.getFormText('app_61.dwnld_title_app2')}.xls`;
            }

            // Второй запрос - скачивание файла
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc61/61/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRep:', error);
            this.error = error;
        }
    }

    private async downloadRepWithChanges() {
        if (!this.isChangesReportAvailable) { return; }
        try {
            this.header.locale = this.$i18n.locale;
            const that = this;
            const repName = this.$i18n.locale === 'kk'
                ? 'МА_ның_ББ_бойынша_шығыстарының_жиынтық_есебі_өзгерістермен.xls'
                : 'Сводный_расчет_расходов_ГУ_с_изменениями.xls';
            await new Promise<void>((resolve, reject) => {
                Ax<Blob>(
                    {
                        url: '/api-py/budg_sum_calc_with_changes/57/' + encodeURIComponent(JSON.stringify(that.header)),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', repName);
                        document.body.appendChild(link);
                        link.click();
                        resolve();
                    },
                    (error) => {
                        that.error = error;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error in downloadRepWithChanges:', error);
            this.error = error;
        }
    }

    private isDownloadButtonEnabled = false;

    private downloadBatchRep() {
        this.isDownloadButtonEnabled = true;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        this.header.locale = this.$i18n.locale;
        const that = this;
        Ax<Blob>(
            {
                url: '/api-py/budg_sum_calc_batch_reports/' + encodeURIComponent(JSON.stringify(that.header)),
                method: 'POST',
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.getFormText('common.batch_dwnld')}.xls`);// or any other extension
                document.body.appendChild(link);
                link.click();
                this.isDownloadButtonEnabled = false;
            },
            (error) => {
                that.error = error;
                this.isDownloadButtonEnabled = false;
            }
        );
    }

    private mounted() {
        this.getModulesAccess();
        this.$watch('store.state.user.userModules', () => { this.getModulesAccess(); });
        this.$watch('tabIndx', () => { this.getTabIndx(); });
    }

    // ------------------
    private getModulesAccess() {
        this.adminAccess = false;
        const accessCost = this.getAccess('004.002.003.001');
        const accessIncome = this.getAccess('004.002.003.002');
        const accessGkkpExpens = this.getAccess('004.002.003.003', false);
        this.enableTab = accessCost.enable;
        this.editableCostAccess = accessCost.editable;
        this.enableIncomeTab = accessIncome.enable;
        this.editableIncomeAccess = accessIncome.editable;
        this.enableGkkpExpensTab = accessGkkpExpens.enable;
        this.editableGkkpExpensAccess = accessGkkpExpens.editable;
        this.getTabIndx();
    }

    private getAccess(code: string, affectsAdmin = true) {
        const modules: any[] = store.state.user.userModules;
        let editable = false;
        let enable = false;
        for (const row of modules) {
            if (row.modules === code) {
                if (row.access_level !== 1) {
                    editable = true;
                }
                if (row.access_level === 3 && affectsAdmin) {
                    this.adminAccess = true;
                }
                if ([1, 2, 3].includes(row.access_level)) {
                    enable = true;
                }
            }
        }
        return { editable, enable };
    }

    // получение статуса, изменены ли данные в дочерних вкладках
    private changedData(changed: boolean) {
        this.changedDataFl = changed;
    }

    private confirmGkkpChange(): boolean {
        if (!this.changedDataFl) { return true; }
        if (confirm('Есть несохранённые изменения. Перейти?')) {
            this.changedDataFl = false;
            return true;
        }
        return false;
    }

    private onActivateTab(newIndex: number, oldIndex: number, bvEvent: any) {
        if (!this.changedDataFl) {
            this.tabIndx = newIndex;
            return;
        }

        if (confirm('Есть несохранённые изменения. Перейти?')) {
            this.tabIndx = newIndex;
            this.changedDataFl = false;
        } else {
            bvEvent.preventDefault();
        }
    }

    // ----------------

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get otherTitle() {
        const obj = {
            mainTitle: this.getBudgetText('other.mainTitle'), // Бюджетное планирование
            subTitle: this.getBudgetText('other.subTitle'), // Бюджетные заявки
            gu_form: this.getBudgetText('sum_calc_edit.gu_form'), // Режим «Формы ГУ»
            sum_cost_calc: this.getBudgetText('sum_calc_edit.sum_cost_calc'), // Раздел «Сводные расчеты расходов»
            description: this.getBudgetText('sum_calc_edit.description'), // Данный раздел содержит сводную информацию расчета расходов государственного учреждения (далее ГУ) по БП, БПП, согласно приказа №185 МФ РК «Об утверждении Правил составления, представления, рассмотрения бюджетного запроса».
            download: this.getBudgetText('button.download'), // Скачать
            save: this.getBudgetText('sum_calc_edit.save'), // Сохранить
            gkkpExpensTab: this.getBudgetText('sum_calc_edit.gkkp_expens_tab'), // Расходы ГККП
            gkkpExpensMode: this.getBudgetText('sum_calc_edit.gkkp_expens_mode'), // Режим «Формы ГУ»
            gkkpExpensSection: this.getBudgetText('sum_calc_edit.gkkp_expens_section'), // Раздел «Расходы ГККП»
            gkkpExpensDescription: this.getBudgetText('sum_calc_edit.gkkp_expens_description'), // Вкладка предназначена для ввода отчётных данных ГККП...
        }
        return obj
    }


    private get filterTitle() {
        const obj = {
            bread: {
                "val0": this.getBudgetText('filter.bread.val0'), //  -регион
                "val1": this.getBudgetText('filter.bread.val1'), //  -версия
                "val2": this.getBudgetText('filter.bread.val2'), //  -АБП
                "gu": this.getBudgetText('sum_calc_gu.gu'), //  ГУ
                "gkkp": this.getBudgetText('filter.bread.val5'), //  -ГККП
                "bp": this.getBudgetText('sum_calc_upload.bp'), //  БП
                "bpp": this.getBudgetText('sum_calc_edit.bpp'), //  БПП
                in_progress: this.getBudgetText('sum_calc_upload.in_progress'), //  Идет загрузка
            }
        }
        return obj;
    }

    private get reportTitle() {
        const arr: any[] = [];
        for (let i = 0; i < this.reportCodes.length; i++) {
            const str = this.getBudgetText(`sum_calc_edit.reports[${i}][0]`) +  this.reportCodes[i].val + this.getBudgetText(`sum_calc_edit.reports[${i}][1]`);
            arr.push(str);
        }
        return arr;
    }

    private get isChangesReportAvailable(): boolean {
        return this.header !== null && [3, 4, '3', '4'].includes(this.header.data_type);
    }

    private get isReport93Available(): boolean {
        return this.header !== null && [4, '4'].includes(this.header.data_type) && this.reportCodes[5].val != null;
    }

    private get isReport94Available(): boolean {
        return this.header !== null && [4, '4'].includes(this.header.data_type) && this.reportCodes[6].val != null;
    }

    private get reportTitleWithChanges(): string {
        const text = this.getFormText('app_57_changes.dwnld_title');
        if (text && !text.includes('app_57_changes')) {
            return text;
        }
        return this.$i18n.locale === 'kk'
            ? 'МА-ның ББ бойынша шығыстарының жиынтық есебі өзгерістермен'
            : 'Сводный расчет расходов ГУ по БП с изменениями';
    }

    private getTabIndx() {
        const oldTabIndxSelected = this.tabIndxSelected;
        const arr = [{name: 'cost', indx: 0}, {name: 'income', indx: 1}, {name: 'gkkpExpens', indx: 2}];
        for (let i = 0; i < arr.length; i++) {
            if (i < 0) { break; }
            if (!this.enableTab && arr[i].name === 'cost') {
                arr.splice(i, 1);
                i--;
            } else if (!this.enableIncomeTab && arr[i].name === 'income') {
                arr.splice(i, 1);
                i--;
            } else if (!this.enableGkkpExpensTab && arr[i].name === 'gkkpExpens') {
                arr.splice(i, 1);
                i--;
            }
        }
        if (this.tabIndx < 0) {
            this.tabIndxSelected = this.tabIndx;
        } else if (arr[this.tabIndx]) {
            this.tabIndxSelected = arr[this.tabIndx].indx;
        } else {
            this.tabIndxSelected = arr.length ? arr[arr.length - 1].indx : -1;
        }
    }
}
